﻿/// <reference path="./libs/phaser.d.ts" />

export namespace BattleCity
{
    export class Stage extends Phaser.State
    {
        stageText: Phaser.Sprite;
        stageNumber: Phaser.Sprite;
        grayBackground: Phaser.Sprite;

        create()
        {
            // Background
            this.grayBackground = this.add.sprite(0, 0, "battleCityScene", "gray_block.png");
            this.grayBackground.width = this.world.width;
            this.grayBackground.height = this.world.height;

            // Stage Text
            this.stageText = this.add.sprite(this.world.width / 2, this.world.height / 2, "battleCityScene", "stage.png");
            this.stageText.anchor.setTo(0.5);

            // Stage Number
            this.stageNumber = this.add.sprite(this.world.width / 2 + this.stageText.width / 2 + 10, this.world.height / 2, "battleCityScene", "_1.png");
            this.stageNumber.anchor.setTo(0, 0.5);

            this.time.events.add(Phaser.Timer.SECOND * 1, this.startLevel, this);
        }

        startLevel()
        {
            this.state.start("Level01");
        }
    }
}
